import React  from 'react';
import '../myutils';
import {
    RefreshButton,
} from 'react-admin'; 
import CardActions from '@material-ui/core/CardActions';
import CreateTemplateButton from '../buttons/CreateTemplateButton';
import QuickSendButton from '../buttons/QuickSendButton';
import { withStyles } from '@material-ui/core/styles';

const styles = {
    cardActionStyle: {
        zIndex: 2,
        display: 'inline-block',
        float: 'right',
    }
};

const TemplateActions = ({
    resource,
    filters,
    displayedFilters,
    filterValues,
    showFilter,
    classes,
}) => (
    <CardActions 
    className={classes.cardActionStyle}
    >
        {filters &&
            React.cloneElement(filters, {
                resource,
                showFilter,
                displayedFilters,
                filterValues,
                context: 'button',
            })}
        <RefreshButton />
        <CreateTemplateButton />
    <QuickSendButton label="Quick-Send"/>

    </CardActions>
);

export default withStyles(styles)(TemplateActions);
